import React, { useRef, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from "yup";
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { createApplication, resendSmsOtp, sendSmsOtp, verifyPanNumber, verifySmsOtp } from '../../../slices/dashboard/dashboardSlice'
import Loader from "../../common/Loader"
import { caseConfirmation, kycLink, panOcr, anmolCheck, dealerCheck, cKycCheck, cKycOtpGenerate, cKycOtpValidate, setSubStage } from '../../../slices/eligibility/eligibilitySlice'
import ImageComponent from '../../common/Image'
import DatePicker from './datePicker';
import axios from 'axios';
import { maskValue } from './masking';

function EligiblityCheck(props) {
  const [showModal, setShowModal] = useState(false);
  const [showconfirmModal, setShowconfirmModal] = useState(false)
  const [successModal, setSuccessModal] = useState(false)
  const [otpValues, setOtpValues] = useState(['', '', '', '', '', '']);
  const [timer, setTimer] = useState("00:00:00");
  const Ref = useRef(null);
  const dispatch = useDispatch()
  const [loader, setLoader] = useState(false);
  const href = "#"
  const [existingCase, setExistingCase] = useState(false)
  const [anmolModal, setAnmolModal] = useState(false)
  const [pan, setPan] = useState()
  const [panData, setPanData] = useState()
  const [kycReuse, setKycReUse] = useState(false)
  const [anmolNumber, setAnmolNumber] = useState()
  const [rejectPopup, setRejectPopup] = useState(false)
  const [cKycPopup, setCkycPopup] = useState(false)
  const [errCode, setErrCode] = useState(false)
  const modalRef = useRef(null);
  const product_disable = useSelector(state => state.auth?.userData?.response_data?.product_disable)
  const [delearListModal, setDelearListModal] = useState(false)
  const [btnDisable, setBtnDisable] = useState(false)
  const [showAnmolErrorGif, setShowAnmolErrorGif] = useState(false)
  const [geoErrorPopup, setGeoErrorPopup] = useState(false)

  const { applicationDetail } = useSelector(state => state.dashboard)
  const { stage } = useSelector(state => state.eligibility)
  const subStageFromStore = useSelector(
    state => state.eligibility?.subStage
  );
  console.log(applicationDetail, "qqqqqqqqq")
  const subStage =
    subStageFromStore && subStageFromStore.trim() !== ''
      ? subStageFromStore
      : 'check_eligibility';
  const [subStageValue, setSubStageValue] = useState(subStage)
  const { source } = useSelector(state => state.auth?.userData?.response_data)
  const refId = applicationDetail?.reference_id ?? ""
  const [referenceId, setReferenceId] = useState(refId)
  let anmolData = applicationDetail?.anmol_number ? true : false
  const [anmolDataPopulated, setAnmolDataPopulated] = useState(anmolData)
  let disable = applicationDetail?.otp_verification ? true : false || applicationDetail?.show_update_page === false
  const [dealerDisable, setDealerDisable] = useState(disable)
  const [anmolVerified, setAnmolVerified] = useState(false)
  const [verifiedData, setVerifiedData] = useState({ "mobile": applicationDetail?.otp_verification ?? "", "pan": applicationDetail?.pan_verification ?? "" })
  const navigate = useNavigate()
  const { userData } = useSelector((state) => state.auth);
  const [values, setValues] = useState([])
  const dealerData = userData?.response_data?.dealer_data || [];
  const userType = userData?.response_data?.userType;
  const [tempMobNo, setTempMobNo] = useState()
  const [otpId, setOtpId] = useState()
  const [showSuspectConfirmModal, setShowSuspectConfirmModal] = useState(false);
  const [ckycSummary, setCkycSummary] = useState()
  const [searchTerm, setSearchTerm] = useState('');
  const [isValueDobMasked, setIsValueDobMasked] = useState(true);
  const [isValueMobileMasked, setIsValueMobileMasked] = useState(true);
  const [isValueCkycMasked, setIsValueCkycMasked] = useState(true);

  function fuzzyScore(needle, haystack) {
    needle = needle.toLowerCase();
    haystack = haystack.toLowerCase();
    let j = 0;
    let matched = 0;

    for (let i = 0; i < needle.length && j < haystack.length; i++) {
      const ch = needle[i];
      j = haystack.indexOf(ch, j);
      if (j === -1) break;
      matched++;
      j++;
    }

    return (matched / needle.length) * 100; // percentage
  }


  const filteredDealers = searchTerm
    ? dealerData
      .map(dealer => {
        const codeScore = fuzzyScore(searchTerm, dealer.dealercode);
        const nameScore = fuzzyScore(searchTerm, dealer.dealername);
        const maxScore = Math.max(codeScore, nameScore); // take best
        return { ...dealer, score: maxScore };
      })
      .filter(d => d.score > 0) // keep only matches
      .sort((a, b) => b.score - a.score) // best match first
    : dealerData;


  const calculateAge = (dob) => {
    if (!dob) return '';

    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };

  const formatMobileNumber = (mobileNo) => {
    if (!mobileNo || mobileNo.length !== 10) return mobileNo;
    return `+91 ${mobileNo.substring(0, 5)} ${mobileNo.substring(5)}`;
  };


  // Convert dates to YYYY-MM-DD format for input
  const formatDate = (date) => date.toISOString().split("T")[0];

  const formatEligibilityDate = (dateStr) => {
    // 1. Split the "29/03/1998" into parts
    const [day, month, year] = dateStr.split('/');

    // 2. Create a new Date object (Note: Month is 0-indexed in JS)
    const date = new Date(year, month - 1, day);

    // 3. Extract parts for YYYY-MM-DD format
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  };

  const eligibiltySchema = Yup.object()
    .shape({
      mobileNo: Yup.string()
        .matches(/^(\d{10}|X{6}\d{4})$/, 'Invalid mobile number')
        .required('Mobile Number is required'),
      dob: Yup.string()
        .required('Date of Birth is required'),
      pan: Yup.string()
        .matches(/^([A-Z]{5}[0-9]{4}[A-Z]|[A-Z]{5}X{4}[A-Z])$/, 'Enter a valid PAN number')
        .required('PAN is required'),
      pincode: Yup.string() // switch to string so we can use regex directly
        .matches(/^[1-9]\d{5}$/, 'Enter valid Pincode')
        .required('Pincode is required'),
      // product: Yup.string()
      //   .required('Product is Required'),
      name: Yup.string()
        .required('Name is Required'),
      gender: Yup.string()
        .required('Gender is Required'),
      // Conditionally require dealerCode only for employees
      dealerCode: userType === 'employee'
        ? Yup.string().required('Basic Details is Required')
        : Yup.string(),
    })

  const formik = useFormik({
    initialValues: {
      mobileNo: applicationDetail?.mobile_number ?? "",
      dob: applicationDetail?.dob ? formatEligibilityDate(applicationDetail?.dob) : '',
      age: applicationDetail?.dob ? calculateAge(applicationDetail.dob) : '',
      pan: applicationDetail?.pan_number ?? "",
      pincode: applicationDetail?.pincode ?? "",
      product: applicationDetail?.product ?? "",
      name: applicationDetail?.name ?? "",
      gender: applicationDetail?.gender ?? "",
      // Set dealer code based on user type
      dealerCode: userType === 'employee'
        ? (applicationDetail?.dealer_code ?? "")
        : (userData?.response_data?.dealer_code ?? ""),
      suspected_activity: applicationDetail?.suspected_activity ?? false,
      panVerified: applicationDetail?.pan_verification ?? false,
      mobileNoVerified: applicationDetail?.otp_verification?.toLowerCase() === "success"
    },
    validationSchema: eligibiltySchema,
    onSubmit: async (values) => {
      verifyPan(values)
    }
  })

  const createCkycApplication = async (values) => {
    let data = {
      reference_id: referenceId,
      pan_number: values.pan,
      mobile: values.mobileNo,
      dob: values.dob,
      gender: values.gender,
      name: values.name
    }
    setLoader(true)
    let response = await dispatch(cKycCheck({
      ...data,
    })).unwrap()
    setLoader(false)
    setBtnDisable(false)
    if (response?.response_code === 'S100') {
      setCkycPopup(response?.response_data?.result?.individual?.[0])
      setValues(values)
    }
    else if (response?.response_code === 'E319') {
      createUserApplication(values)
    }
    else if (response?.response_code === 'E150') {
      navigate('/dashboard')
      toast.error(response?.response_string, {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
    }
    else {
      !response?.payload?.error &&
        toast.error(response?.response_string, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
    }
  }

  const createUserApplication = async (values) => {
    let data = {
      "reference_id": referenceId, ...formik?.values
    }
    setLoader(true)
    const response = await dispatch(createApplication(data))
    setLoader(false)
    setBtnDisable(false)
    if (response?.payload?.response_code === 'S100') {
      setSuccessModal(response?.payload?.response_string)
    }
    else if (response?.payload?.response_code === 'E135') {
      setRejectPopup(response?.payload?.response_string)
    }
    else {
      !response?.payload?.error &&
        toast.error(response?.payload?.response_string, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
    }

  }

  useEffect(() => {
    if (formik.values.dob) {
      const calculatedAge = calculateAge(formik.values.dob);
      formik.setFieldValue('age', calculatedAge);
    } else {
      formik.setFieldValue('age', '');
    }
  }, [formik.values.dob]);

  const verifyPan = async (values) => {
    if (((/^[A-Z]{5}\d{4}[A-Z]$/).test(formik?.values?.pan) || ((/^[A-Z]{5}X{4}[A-Z]$/).test(formik?.values?.pan) && formik?.values?.panVerified)) && (formik?.values?.dob) && (formik?.values?.mobileNoVerified)) {
      setLoader(true);
      setBtnDisable(true)
      let payloadData = {
        "reference_id": referenceId,
        "pan_number": formik?.values?.pan,
        "dob": formik?.values?.dob,
        'name': formik?.values?.name,
        'age': "" + formik?.values?.age,
        pincode: formik?.values?.pincode,
        gender: formik?.values?.gender
      }
      try {
        const response = await dispatch(verifyPanNumber({
          data: payloadData,
          encrypt: true
        }))
        setBtnDisable(false)
        setOtpId()
        if (response?.payload?.response_code === 'S101') {
          formik?.setFieldValue("pan", response?.payload?.response_data?.pan_number)
          // formik?.setFieldValue("panVerified", true)
          // setVerifiedData({ ...verifiedData, "pan": value })
          setSubStageValue('product_selection')
          if (response?.payload?.response_data?.reuse_flag === true) {
            formik?.setFieldValue("pincode", response?.payload?.response_data?.pincode)
            formik?.setFieldValue("gender", response?.payload?.response_data?.gender)
            setAnmolDataPopulated(true)
          }
          formik?.setFieldValue("name", response?.payload?.response_data?.name)
        }
        else if (response?.payload?.response_code === 'E333') {
          setSubStageValue('product_selection')
        }
        else if (response?.payload?.response_code === 'S100') {
          setCkycPopup(response?.payload?.response_data?.result?.individual?.[0])
          setValues(values)
        }
        else if (response?.payload?.response_code === 'E319') {
          createUserApplication(values)
        }
        else if (response?.payload?.response_code === 'E150') {
          navigate('/dashboard')
          toast.error(response?.payload?.response_string, {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          });
        }
        else if (response?.payload?.response_code === 'E194' || response?.payload?.response_code === "E173") {
          setErrCode(response?.payload?.response_code)
          setExistingCase(response?.payload?.response_data)
        }
        else if (response?.payload?.response_code === 'E135') {
          navigate('/dashboard')
          toast.error(response?.payload?.response_string, {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          });
        }
        else {
          !response?.payload?.error &&
            toast.error(response?.payload?.response_string, {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined
            });
        }
      } finally {
        setLoader(false); // Add loader end
      }
    }
    else {
      toast.error(
        (!(/^[A-Z]{5}\d{4}[A-Z]$/).test(formik?.values?.pan) && 'Please enter a valid PAN number') ||
        (!formik?.values?.pan && "Please enter a PAN number to verify") || (!formik?.values?.mobileNoVerified && "Please verify mobile number") ||
        (!formik?.values?.dob && "Date of Birth is mandatory"),
        {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        }
      );
    }
  }

  const getUserLocation = async (shouldUseGeolocation = true) => {
    if (!shouldUseGeolocation) {
      // Prevent unnecessary access
      return Promise.reject(new Error("Geolocation access is not necessary."));
    }

    if (!navigator.geolocation) {
      toast.error('Geolocation is not supported by your browser');
      return Promise.reject(new Error("Geolocation is not supported by your browser"));
    }

    return new Promise((resolve, reject) => {
      // ⚠️ Only call this if geolocation is truly necessary
      //NOSONAR
      navigator.geolocation.getCurrentPosition( //NOSONAR
        (position) => {
          resolve(position.coords);
        },
        (err) => {
          if (err.code === 1) {
            toast.error('Please allow location access to continue');
          } else {
            toast.error('Error getting location');
          }
          reject(err);
        }
      );
    });
  };

  console.log(applicationDetail)

  const sendOtp = async () => {
    if ((/^[6-9]\d{9}$/).test(formik?.values?.mobileNo) || ((/^(\d{10}|X{6}\d{4})$/).test(formik?.values?.mobileNo))) {
      setLoader(true);
      try {
        const location = await getUserLocation();
        let data = {
          "mobile_number": formik?.values?.mobileNo,
          "source": source,
          "dealer_code": formik?.values?.dealerCode,
          tc_lead: applicationDetail?.tc_lead_id ? true : false,
          tc_lead_id: applicationDetail?.tc_lead_id,
          latitude: +location.latitude,
          longitude: +location.longitude,
          ...(anmolVerified && { anmol_number: anmolNumber || "" })
        }
        const response = await dispatch(sendSmsOtp(data))
        if (response?.payload?.response_code === 'S100') {
          setReferenceId(response?.payload?.response_data?.reference_id)
          setShowModal(true)
          setTimer("01:00");
          setTempMobNo(response?.payload?.response_data?.mobile_number)
          setVerifiedData({ ...verifiedData, "mobile": formik?.values?.mobileNo })
          clearTimer(getDeadTime());
        }
        else if (response?.payload?.response_code === 'E154') {
          setGeoErrorPopup(response?.payload?.response_string)
        }
        else {
          !response?.payload?.error &&
            toast.error(response?.payload?.response_string, {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined
            });
        }
      } finally {
        setLoader(false); // Add loader end
      }
    } else {
      toast.error((formik?.values?.mobileNo ? 'Please enter a valid mobile number' : "Please enter a mobile number to verify"), {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      });
    }
  }

  const verifyOtp = async () => {
    setLoader(true);
    let data = {
      "reference_id": referenceId,
      "otp": otpValues?.join(''),
      tc_lead: applicationDetail?.show_update_page === false ? true : false
    }
    try {
      const response = await dispatch(verifySmsOtp(data))
      if (response?.payload?.response_code === 'S100') {
        // toast.success(response?.payload?.response_string);
        setShowModal(false)
        formik?.setFieldValue("mobileNo", tempMobNo)
        formik?.setFieldValue("mobileNoVerified", true)
      }
      else {
        !response?.payload?.error &&
          toast.error(response?.payload?.response_string, {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          });
      }
    } finally {
      setLoader(false); // Add loader end
    }
  }

  useEffect(() => {
    if (userType?.toLowerCase() === 'dealer' && dealerData.length > 0) {
      setAnmolModal(true);
      if (!formik.values.dealerCode) {
        const firstDealer = dealerData[0];
        formik.setFieldValue('dealerCode', firstDealer.dealercode);
      }
    }
  }, [userType, dealerData, formik.values.dealerCode]);

  const resendOtp = async () => {
    setLoader(true);
    let data = {
      "reference_id": referenceId,
    }
    try {
      const response = await dispatch(resendSmsOtp(data))
      if (response?.payload?.response_code === 'S100') {
        setOtpValues(['', '', '', '', '', ''])
        setTimer("01:00");
        clearTimer(getDeadTime());
        // toast.success((response?.payload?.response_string), {
        //   position: 'top-right',
        //   autoClose: 3000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined
        // });
      }
      else {
        !response?.payload?.error &&
          toast.error(response?.payload?.response_string, {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          });
      }
    } finally {
      setLoader(false); // Add loader end
    }
  }

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());  // Get total remaining time in milliseconds
    const seconds = Math.floor((total / 1000) % 60);  // Remaining seconds
    const minutes = Math.floor((total / 1000 / 60) % 60);  // Remaining minutes

    return { total, minutes, seconds };
  };

  // Function to start the timer and update the state
  const startTimer = (e) => {
    let { total, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      // Update the timer if time is still remaining
      setTimer(
        (minutes > 9 ? minutes : "0" + minutes) + ":" + (seconds > 9 ? seconds : "0" + seconds)
      );
    } else {
      // If time is over, clear the interval
      clearInterval(Ref.current);
    }
  };

  // Function to clear the previous interval and start a new one
  const clearTimer = (e) => {
    setTimer("01:00");  // Reset timer to 120 seconds (2 minutes)

    // Clear the previous interval (if any)
    if (Ref.current) clearInterval(Ref.current);

    // Set a new interval to update the timer every second
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;  // Store the interval ID in Ref
  };

  // Function to get the deadline (current time + 120 seconds)
  const getDeadTime = () => {
    let deadline = new Date();
    deadline.setSeconds(deadline.getSeconds() + 60);  // Add 120 seconds (2 minutes)
    return deadline;
  };

  const handlePanUppercaseChange = (e) => {
    const value = e.target.value.toUpperCase();
    // /^[A-Z]{0,5}\d{0,4}[A-Z]?$/
    //  └─ up to 5 letters    └─ up to 4 digits   └─ optional 1 letter
    const regex = /^[A-Z]{0,5}\d{0,4}[A-Z]?$/;

    if (value === "" || (regex.test(value) && value.length <= 10)) {
      formik.setFieldValue("pan", value);
    }
  };

  const handleKycLink = async () => {
    // const response = await dispatch(kycLink({ "reference_id": referenceId }))
    // if (response?.payload?.response_code === 'S100') {
    navigate(`/consumerId?referenceId=${referenceId}`)
    // }
    // else {
    //   toast.error(response?.payload?.response_string, {
    //     position: 'top-right',
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined
    //   });
    // }
  }

  const showModalPopup = (data) => {
    setShowconfirmModal(data)
  }

  const toBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  const handleFileChange = async (event) => {
    const fieldName = event.currentTarget.name;  // get input name dynamically
    const file = event.currentTarget.files[0];
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

    if (file) {
      if (allowedTypes.includes(file.type)) {
        const base64 = await toBase64(file);
        let data = {
          reference_id: referenceId,
          pan_base_64: base64
        }
        setLoader(true)
        const response = await dispatch(panOcr(data)).unwrap()
        setLoader(false)
        if (response?.response_code === 'S100') {
          setPan(response?.response_data?.pan_number)
          setPanData(response?.response_data)
        }
        else {
          !response?.payload?.error &&
            toast.error(response?.response_string, {
              position: 'top-right',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined
            });
        }
      } else {
        formik.setFieldValue(fieldName, '');
        formik.setFieldError(fieldName, 'Only JPEG, JPG, & PNG files are allowed');
      }
    }
  };

  const today = new Date();

  // Calculate max DOB: today - 21 years
  const maxDate = new Date(today.getFullYear() - 21, today.getMonth(), today.getDate());

  // Calculate min DOB: today - 58 years
  const minDate = new Date(today.getFullYear() - 58, today.getMonth(), today.getDate());

  const dealerCode = showconfirmModal ? showconfirmModal : formik?.values?.dealerCode

  const selectedDealer = dealerData.find(d => d.dealercode === dealerCode);

  const setPanNumber = () => {
    formik?.setFieldValue("pan", pan)
    formik?.setFieldValue("dob", panData?.pan_dob)
    const calculatedAge = calculateAge(panData?.dob);
    formik.setFieldValue('age', calculatedAge);
    formik?.setFieldValue("name", panData?.pan_name)
    setPan()
    // verifyPan(pan)
  }

  const saveApplicationId = async (id, cancel_id, type) => {
    setLoader(true)
    let response = await dispatch(caseConfirmation(
      {
        "selected_reference_id": id,
        "cancelled_reference_ids": [cancel_id],
        kyc_reuse: kycReuse
      }
    )).unwrap()
    setLoader(false)
    if (response?.response_code === 'S100') {
      setExistingCase(false)
      if (type === 'confirm') {
        setAnmolDataPopulated(true)
        formik?.setFieldValue("pincode", response?.response_data?.pincode || "");
        const genderRaw = response?.response_data?.gender?.toLowerCase();
        let genderValue = ''
        if (genderRaw === 'male') {
          genderValue = 'Male';
        } else if (genderRaw === 'female') {
          genderValue = 'Female';
        }
        formik?.setFieldValue("gender", genderValue);
      }
      if (type === 'cancel') {
        navigate(`/dashboard`)
      }
    }
    else {
      !response?.payload?.error &&
        toast.error(response?.response_string, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
    }
  }

  const handleOtpChange = (index, value) => {
    // Allow only digits
    if (!/^\d*$/.test(value)) return;

    const newOtpValues = [...otpValues];
    newOtpValues[index] = value.slice(-1); // Ensure only the last digit is used
    setOtpValues(newOtpValues);

    // Auto-move to next input
    if (value && index < otpValues.length - 1) {
      const nextInput = document.querySelector(`input[data-index="${index + 1}"]`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    const key = e.key;

    if (key === 'Backspace') {
      if (otpValues[index]) {
        // Clear current value
        const newOtpValues = [...otpValues];
        newOtpValues[index] = '';
        setOtpValues(newOtpValues);
      } else if (index > 0) {
        // Move focus to previous input
        const prevInput = document.querySelector(`input[data-index="${index - 1}"]`);
        if (prevInput) prevInput.focus();
      }
    }

    if (key === 'ArrowLeft' && index > 0) {
      const prevInput = document.querySelector(`input[data-index="${index - 1}"]`);
      if (prevInput) prevInput.focus();
    }

    if (key === 'ArrowRight' && index < otpValues.length - 1) {
      const nextInput = document.querySelector(`input[data-index="${index + 1}"]`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData('text').trim().replace(/\D/g, ''); // numbers only
    if (paste.length === otpValues.length) {
      setOtpValues(paste.split(''));
      // Optional: move focus to last input
      const lastInput = document.querySelector(`input[data-index="${otpValues.length - 1}"]`);
      if (lastInput) lastInput.focus();
    }
  };

  const checkAnmolData = async () => {
    setLoader(true);
    try {
      const data = {
        anmol_number: anmolNumber
      };

      const response = await dispatch(anmolCheck(data)).unwrap();

      if (response?.response_code == 'S100') {
        const responseData = response?.response_data;

        toast.success(response?.response_string)

        // Show success gif and disable buttons
        setShowAnmolErrorGif(true);
        setAnmolVerified(true);

        // Close modal after 5 seconds
        setTimeout(() => {
          // Populate form fields with API response data
          formik?.setFieldValue("mobileNo", responseData?.mobile_number || "");
          setMobileNo(responseData?.mobile_number || "")
          formik?.setFieldValue("dob", responseData?.dob || "");
          formik?.setFieldValue("pan", responseData?.pan_number || "");
          formik?.setFieldValue("name", responseData?.name || "");
          formik?.setFieldValue("pincode", responseData?.pincode || "");
          formik?.setFieldValue("gender", responseData?.gender === 'male' ? 'Male' : responseData?.gender === 'female' ? 'Female' : "");

          setAnmolDataPopulated(true);
          setAnmolModal(false);
          setShowAnmolErrorGif(false);


        }, 5000);
      } else {
        setAnmolVerified(false);
        !response?.payload?.error &&
          toast.error(response?.response_string);
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  }

  const mobileNumberRegex = /^[6-9]\d{0,9}$/; // Example: Indian mobile number start 6-9, max 10 digits

  const [mobileNo, setMobileNo] = React.useState(formik?.values?.mobileNo);

  const handleMobileChange = (e) => {
    const val = e.target.value;
    const digitsOnly = val.replace(/\D/g, ''); // replaces non-digits

    const isAllSameDigit = /^(\d)\1{9}$/.test(digitsOnly); // checks for same digit 10 times

    const isValidFormat = mobileNumberRegex.test(digitsOnly);

    if (digitsOnly === '' || (isValidFormat && !isAllSameDigit)) {
      setMobileNo(digitsOnly);
      formik.setFieldValue('mobileNo', digitsOnly);
    } else {
    }
  };

  const [otpIds] = React.useState(() =>
    otpValues.map(() => crypto.randomUUID()) // or some unique ID generator
  );

  const checkStatus = async () => {
    setLoader(true)
    const response = await dispatch(dealerCheck({
      dealer_code: showconfirmModal
    })).unwrap()
    setLoader(false)
    if (response?.response_code === 'S100') {
      formik?.setFieldValue("dealerCode", showconfirmModal);
      props?.setDealerCode(showconfirmModal);
      setAnmolModal(true);
      setShowconfirmModal(false);
      setDealerDisable(true)
    }
    else {
      !response?.payload?.error &&
        toast.error(response?.response_string, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
    }
  }

  function convertDateFormat(dateString) {
    if (!dateString) return '';

    const [year, month, day] = dateString.split('-');

    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    return `${day} ${months[Number(month) - 1]} ${year}`;

    // const regex: RegExp = /^\d{4}-\d{2}-\d{2}$/;
    // if (!regex.test(dateString)) {
    //   console.error('Invalid date format. Expected format is yyyy-mm-dd.');
    //   return dateString;
    // }

    // const [year, month, day]: string[] = dateString.split('-');
    // const formattedDate: string = `${day}-${month}-${year}`;
    // return formattedDate;
  }

  const generateCkycotp = async () => {
    try {
      setLoader(true)
      const response = await dispatch(cKycOtpGenerate({ reference_id: referenceId })).unwrap();
      setLoader(false)
      if (response?.response_code === 'S100') {
        setOtpValues(['', '', '', '', '', '']);
        setOtpId(response?.response_data?.requestId);
        setTimer("01:00");
        clearTimer(getDeadTime());
      }
      else if (response?.response_code === 'S101') {
        setCkycPopup(false)
        formik?.setFieldValue("pan", response?.response_data?.pan_number)
        // formik?.setFieldValue("panVerified", true)
        // setVerifiedData({ ...verifiedData, "pan": value })
        setSubStageValue('product_selection')
        if (response?.response_data?.reuse_flag === true) {
          formik?.setFieldValue("pincode", response?.response_data?.pincode)
          formik?.setFieldValue("gender", response?.response_data?.gender)
          setAnmolDataPopulated(true)
        }
        formik?.setFieldValue("name", response?.response_data?.name)
      }
      else if (response?.response_code === 'E150') {
        navigate('/dashboard')
        toast.error(response?.response_string, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      }
      else if (response?.response_code === 'E323') {
        setCkycPopup(false)
        setSubStageValue('product_selection')
      }
      else if (response?.response_code === 'E348' || response?.response_code === 'E349' || response?.response_code === 'E350' || response?.response_code === 'E351') {
        setCkycPopup(false)
        toast.error(response?.response_string);
      }
      else {
        !response?.payload?.error &&
          toast.error(response?.response_string);
      }
    } catch (error) {
      setLoader(false)
      console.error('Error generating CKYC OTP:', error);
      toast.error('Failed to generate CKYC OTP');
    }
  }

  const verifyCkycOtp = async () => {
    try {
      setLoader(true)
      const response = await dispatch(cKycOtpValidate({ reference_id: referenceId, otp: otpValues.join(''), request_id: otpId })).unwrap();
      setLoader(false)
      if (response?.response_code === 'S100') {
        setCkycSummary(response?.response_data);
        setOtpValues(['', '', '', '', '', '']);
      }
      else if (response?.response_code === 'S101') {
        setCkycPopup(false)
        formik?.setFieldValue("pan", response?.response_data?.pan_number)
        // formik?.setFieldValue("panVerified", true)
        // setVerifiedData({ ...verifiedData, "pan": value })
        setSubStageValue('product_selection')
        if (response?.response_data?.reuse_flag === true) {
          formik?.setFieldValue("pincode", response?.response_data?.pincode)
          formik?.setFieldValue("gender", response?.response_data?.gender)
          setAnmolDataPopulated(true)
        }
        formik?.setFieldValue("name", response?.response_data?.name)
      }
      else if (response?.response_code === 'E150') {
        navigate('/dashboard')
        toast.error(response?.response_string, {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      }
      else if (response?.response_code === 'E324') {
        setCkycPopup(false)
        setSubStageValue('product_selection')
      }
      else if (response?.response_code === 'E348' || response?.response_code === 'E349' || response?.response_code === 'E350' || response?.response_code === 'E351') {
        setCkycPopup(false)
        toast.error(response?.response_string);
      }
      else {
        !response?.payload?.error &&
          toast.error(response?.response_string);
      }
    } catch (error) {
      setLoader(false)
      console.error('Error verifying CKYC OTP:', error);
      toast.error('Failed to verify CKYC OTP');
    }
  }

  console.log(cKycPopup, subStage, formik?.errors, formik?.values)

  return (
    <form onSubmit={formik?.handleSubmit}>
      {userType === 'employee' || userType === 'dealer' ? (
        <div className="container-fluid">
          <div className="card tab-no-border">
            <div className={`dealer-body${stage !== 'credit_decision' ? ' select-store-tab' : ''}`}>
              <div className="row">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between class-dealer-created align-items-center class-dealer-created-custom">
                    <div className="w-100">
                      <input
                        className={`form-control input-underline dealer-custom dealer-input ${formik.errors.dealerCode && formik.touched.dealerCode ? 'is-invalid' : ''}`}
                        placeholder="Select Store"
                        type="text"
                        name="dealerCode"
                        value={formik.values.dealerCode && selectedDealer
                          ? `${formik.values.dealerCode} - ${selectedDealer.dealername}`
                          : ''}
                        readOnly
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            setDelearListModal(true)
                          }
                        }}
                        onClick={(userType === 'employee' && !dealerDisable) ? () => { setDelearListModal(true) } : undefined}
                        style={userType === 'dealer' ? { cursor: 'default' } : { cursor: 'pointer' }}
                      />
                    </div>
                    {userType === 'employee' && (
                      <div>
                        <i
                          className="arrow icon-arrowdown-L1 fs-4"
                          role="button"
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              setDelearListModal(true)
                            }
                          }}
                          onClick={(userType === 'employee' && !dealerDisable) ? () => { setDelearListModal(true) } : undefined}
                        ></i>
                      </div>
                    )}
                  </div>
                  {formik.errors.dealerCode && formik.touched.dealerCode && (
                    <div className="text-danger small mt-1">{formik.errors.dealerCode}</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {!formik.values.dealerCode && (
            <div className="kyc-tab-dash">
              <div className="d-flex justify-content-center">
                <ImageComponent fileName="emptydealer.svg" className="img-fluid" alt="emptydealer" />
              </div>
              <p className="text-center">Kindly select a store</p>
            </div>
          )}
        </div>
      ) : null}

      {(userType !== 'employee' || formik?.values?.dealerCode) &&
        <>
          <div className='row tab-row-eligibility'>
            <div className='col-md-6'>
              <div className="webstepper SideScroll tab-basic-details-stepper">
                <p className="dark-blue fw-semibold">Complete steps</p>
                <p className="small">You are few steps away from obtaining your<br />Consumer Durable Loan</p>
                <div className="steps-vertical">
                  <div className="step-vertical active">
                    <div className="step-vertical-icon"></div>
                    <div className="step-vertical-content">
                      <p className="stp">Step 1</p>
                      <h6 className="name">Basic Details</h6>
                      <p className="status">In-progress</p>
                    </div>
                  </div>
                  <div className="step-vertical pending">
                    <div className="step-vertical-icon"></div>
                    <div className="step-vertical-content">
                      <p className="stp">Step 2</p>
                      <h6 className="name">KYC</h6>
                      <p className="status">Pending</p>
                    </div>
                  </div>
                  <div className="step-vertical pending">
                    <div className="step-vertical-icon"></div>
                    <div className="step-vertical-content">
                      <p className="stp">Step 3</p>
                      <h6 className="name">Product Details</h6>
                      <p className="status">Pending</p>
                    </div>
                  </div>
                  <div className="step-vertical pending">
                    <div className="step-vertical-icon"></div>
                    <div className="step-vertical-content">
                      <p className="stp">Step 4</p>
                      <h6 className="name">Bank Details</h6>
                      <p className="status">Pending</p>
                    </div>
                  </div>
                  <div className="step-vertical pending">
                    <div className="step-vertical-icon"></div>
                    <div className="step-vertical-content">
                      <p className="stp">Step 5</p>
                      <h6 className="name">Documents</h6>
                      <p className="status">Pending</p>
                    </div>
                  </div>
                  <div className="step-vertical pending">
                    <div className="step-vertical-icon"></div>
                    <div className="step-vertical-content">
                      <p className="stp">Step 6</p>
                      <h6 className="name">IMEI Validation</h6>
                      <p className="status">Pending</p>
                    </div>
                  </div>
                  <div className="step-vertical pending">
                    <div className="step-vertical-icon"></div>
                    <div className="step-vertical-content">
                      <p className="stp">Step 7</p>
                      <h6 className="name">Invoice Details</h6>
                      <p className="status">Pending</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-6'>
              <div className="container-fluid eligible-scroll tab-eligible-scroll">
                <div className=" kyc-tab-eligible">
                  {subStageValue === 'check_eligibility' && <>
                    <div className="row floating-bottom">
                      <div className={`col-12 `}>
                        <div className="input-container has-icon">
                          <input
                            className={`form-control input-underline ps-0 ${anmolDataPopulated ? 'custom-disable' : ''}`}
                            id="customer-mobile-no"
                            readOnly={formik?.values?.mobileNoVerified || anmolDataPopulated}
                            type="tel"
                            name="mobileNo"
                            maxLength={10}
                            value={mobileNo}
                            onChange={handleMobileChange}
                            inputMode="numeric"
                            autoComplete="off"
                            placeholder=" "
                            required
                            disabled={applicationDetail?.show_update_page === false}
                          />
                          <label className="label form-label" htmlFor='customer-mobile-no'>Customer Mobile Number</label>
                          <div className="underline"></div>
                          {formik.errors.mobileNo && formik.touched.mobileNo && (
                            <div className="text-danger">{formik.errors.mobileNo}</div>
                          )}
                          {formik?.values?.mobileNo?.length === 10 &&
                            <div>
                              {formik?.values?.mobileNoVerified ? (
                                <i className="icon-Essetional-green-Icon">
                                  <span className="verified">Verified</span>
                                  <span className="path1"></span>
                                  <span className="path2"></span>
                                </i>
                              ) : (
                                <button type="button" className="verify-btn btn-outline-primary" onClick={() => sendOtp()} disabled={formik?.values?.mobileNo?.length !== 10}>Verify</button>
                              )}
                            </div>}
                        </div>
                      </div>
                    </div>
                    <div className="row floating-bottom">
                      <div className={`col-12 ${anmolDataPopulated ? 'custom-disable' : ''}`}>
                        <div className="input-container has-icon">
                          <input className={`form-control input-underline ps-0`} id='customer-pan' readOnly={formik?.values?.panVerified || anmolDataPopulated || !formik?.values?.mobileNoVerified || applicationDetail?.show_update_page === false} type="text" required placeholder=' ' name="pan" value={formik?.values?.pan} onChange={(formik?.values?.panVerified || anmolDataPopulated) ? formik?.handleChange : handlePanUppercaseChange} autoComplete='off' />
                          <label className="label form-label" htmlFor='customer-pan'>PAN</label>
                          <div className="underline"></div>
                          {formik.errors.pan && formik.touched.pan && (
                            <div className="text-danger">{formik.errors.pan}</div>
                          )}
                          <div>
                            {formik?.values?.panVerified ? (
                              <i className="icon-Essetional-green-Icon d-none">
                                <span className="verified">Verified</span>
                                <span className="path1"></span>
                                <span className="path2"></span>
                              </i>
                            ) : (
                              (/^[A-Z]{5}\d{4}[A-Z]$/).test(formik?.values?.pan) ? (
                                <button
                                  type="button"
                                  className="verify-btn btn-outline-primary d-none"
                                  onClick={() => verifyPan(formik?.values?.pan)}
                                >
                                  Verify
                                </button>
                              ) : (
                                <>
                                  <button
                                    type="button"
                                    className="border-0 verify-btn btn-outline-primary scan-border pe-0"
                                    onClick={() => document.getElementById('file-2').click()}
                                    style={{
                                    }}
                                  >
                                    <ImageComponent fileName="camera.svg" alt="scan" />
                                    <input
                                      type="file"
                                      name="pan_img"
                                      id="file-2"
                                      accept=".jpeg, .jpg, .png"
                                      onChange={handleFileChange}
                                      className="inputfile inputfile-1"
                                      capture="environment"
                                      style={{ display: 'none' }}
                                    />
                                  </button>
                                </>
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row floating-bottom">
                      <div className={`col-12`}>
                        <label className="form-label dob-label" htmlFor='dob'>Date of Birth</label>
                        <div>
                          <DatePicker
                            value={formik?.values?.dob}
                            onChange={(value) => formik?.setFieldValue('dob', value)}
                            label=""
                            required={true}
                            disabled={formik?.values?.panVerified || anmolDataPopulated || !formik?.values?.pan || applicationDetail?.show_update_page === false}
                            mobileVerified={formik?.values?.mobileNoVerified}
                            min={formatDate(minDate)}
                            max={formatDate(maxDate)}
                            id="dob"
                            name="dob"
                            placeholder=""
                            autoComplete="off"
                          />
                        </div>
                        {formik.errors.dob && formik.touched.dob && (
                          <div className="text-danger">{formik.errors.dob}</div>
                        )}
                      </div>
                    </div>
                    <div className="row floating-bottom">
                      <div className="col-12 custom-disable age-div">
                        <label className="form-label age-label" htmlFor='age'>Age</label>
                        <div className="d-flex gap-2">
                          <input className="form-control input-underline ps-0 custom-age" id='customer-age' type="text" name="age" value={`${formik?.values?.age ? formik?.values?.age + " years" : formik?.values?.age || "-"}`} onChange={formik?.handleChange} readOnly />
                        </div>
                      </div>
                    </div>
                    <div className="row floating-bottom">
                      <div className="col-12">
                        <div className="input-container has-icon">
                          <input
                            className="form-control input-underline ps-0"
                            id="customer-name"
                            type="text"
                            name="name"
                            value={formik?.values?.name}
                            onChange={(e) => {
                              const value = e.target.value;
                              const filteredValue = value.replace(/[^a-zA-Z.\s]/g, '');
                              formik.setFieldValue('name', filteredValue);
                            }}
                            autoComplete="off"
                            required
                            placeholder=''
                            disabled={(!formik?.values?.pan) || !(/^[A-Z]{5}\d{4}[A-Z]$/).test(formik?.values?.pan) || applicationDetail?.show_update_page === false}
                          />
                          <label className="form-label label" htmlFor='customer-name'>Enter Name (As per PAN Card)</label>
                          <div className="underline"></div>
                          {formik.errors.name && formik.touched.name && (
                            <div className="text-danger">{formik.errors.name}</div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row floating-bottom">
                      <div className={`col-12 align-content-end ${anmolDataPopulated ? 'custom-disable' : ''}`}>
                        <div className="input-container has-icon">
                          <input className={`form-control cust-pin input-underline ps-0`} autoComplete='off' id='customer-pincode' type="tel" name="pincode" maxLength={6} value={formik?.values?.pincode} onChange={formik?.handleChange} placeholder=' ' required readOnly={anmolDataPopulated || !formik?.values?.name || applicationDetail?.show_update_page === false} />
                          <label className="label form-label" htmlFor='customer-pincode'>Pincode</label>
                          <div className="underline"></div>
                          {formik.errors.pincode && formik.touched.pincode && (
                            <div className="text-danger">{formik.errors.pincode}</div>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-12">
                          <span className='fs-11'>(as per Comm. Address)</span>
                        </div>
                      </div>
                    </div>
                    <div className="row floating-bottom">
                      <div className="col-12 d-flex flex-column">
                        <label className="form-label mb-1 gender-label" htmlFor="gender">Gender</label>
                        <div className="d-flex gap-2 genderbg-btn">
                          <input
                            type="radio"
                            className="btn-check"
                            name="gender"
                            id="gender-male"
                            value="Male"
                            onChange={formik.handleChange}
                            checked={formik.values.gender === 'Male'}
                            disabled={anmolDataPopulated || !formik?.values?.pincode || applicationDetail?.show_update_page === false}
                          />
                          <label className="btn btn-outline-primary custom-gender-btn flex-fill width-50 fw-500" htmlFor="gender-male">Male</label>

                          <input
                            type="radio"
                            className="btn-check"
                            name="gender"
                            id="gender-female"
                            value="Female"
                            onChange={formik.handleChange}
                            checked={formik.values.gender === 'Female'}
                            disabled={anmolDataPopulated || !formik?.values?.pincode || applicationDetail?.show_update_page === false}
                          />
                          <label className="btn btn-outline-primary custom-gender-btn flex-fill fw-500 width-50" htmlFor="gender-female">Female</label>
                        </div>
                        {/* Error display */}
                        {formik.errors.gender && formik.touched.gender && (
                          <div className="text-danger" style={{ width: "105px" }}>{formik.errors.gender}</div>
                        )}
                      </div>
                    </div>
                  </>
                  }
                  {subStageValue === 'product_selection' &&
                    <>
                      <div className="row floating-bottom product-bottom">
                        <div className="col-12 ">
                          <label className="form-label mb-2" htmlFor='customer-product'>Product</label>
                        </div>

                        <div className="col-12 col-sm-12 col-xs-12 col-md-12 col-lg-12">
                          <div className={`radio-opt-pay ${product_disable?.toLowerCase() === "cdl" ? 'radio-opt-disable' : ''} disbursal-radio d-flex gap-3`}>
                            <div className="w-100">
                              <input
                                type="radio"
                                id="product-consumer"
                                name="product"
                                value="Consumer Durable"
                                onChange={formik.handleChange}
                                disabled={product_disable?.toLowerCase() === 'cdl'}
                                checked={formik.values.product === "Consumer Durable"}
                              />
                              <label htmlFor="product-consumer">
                                <ImageComponent fileName="homeapp.svg" className="img-fluid mt-2 cd-img" alt="homeapp" />
                                <p className="dark-blue small fw-semibold mt-0 cdl">Consumer Durables</p>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-xs-12 col-md-12 col-lg-12 mt-2">
                          <div className={`radio-opt-pay ${product_disable?.toLowerCase() === "dpl" ? 'radio-opt-disable' : ''} disbursal-radio d-flex gap-3`}>
                            <div className="w-100">
                              <input
                                type="radio"
                                id="product-digital"
                                name="product"
                                value="Digital Products"
                                onChange={formik.handleChange}
                                disabled={product_disable?.toLowerCase() === 'dpl'}
                                checked={formik.values.product === "Digital Products"}
                              />
                              <label htmlFor="product-digital">
                                <ImageComponent fileName="laptoppp.svg" className="img-fluid mt-2 dp-img" alt="laptoppp" />
                                <p className="dark-blue small fw-semibold mt-0 dpl">Digital Products</p>
                              </label>
                            </div>
                          </div>
                        </div>

                      </div>
                      {formik.errors.product && formik.touched.product && (
                        <div className="text-danger">{formik.errors.product}</div>
                      )}

                      <div className="row floating-bottom">
                        <div className="col-12">
                          <div className="form-group">
                            <div className="form-check form-check-inline ps-0">
                              <label className="form-check-label small ps-0" htmlFor="suspected-activity-radio">
                                Any Suspected Activity ?
                              </label>
                            </div>

                          </div>
                          {/* Radio buttons for Yes/No */}
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="suspected_activity_radio"
                              id="suspected-activity-yes"
                              value="yes"
                              checked={formik.values.suspected_activity === true}
                              onChange={() => {
                                formik.setFieldValue('suspected_activity', true);
                                setShowSuspectConfirmModal(true);
                              }}
                            />
                            <label className="form-check-label" htmlFor="suspected-activity-yes">
                              Yes
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="suspected_activity_radio"
                              id="suspected-activity-no"
                              value="no"
                              checked={formik.values.suspected_activity === false}
                              onChange={() => {
                                formik.setFieldValue('suspected_activity', false);
                              }}
                            />
                            <label className="form-check-label" htmlFor="suspected-activity-no">
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </div>
              </div>

              <footer className="sticky-bottom-1 tab-eligibility-sticky-bottom">
                <div className="container-fluid tab-eligibility-continue-cont">
                  <div className="row">
                    {subStageValue === 'check_eligibility' &&
                      <div className="col-sm-12">
                        <div className="d-flex">
                          <button
                            className="btn btn-primary w-100 small continue-btn"
                            type="submit button"
                            disabled={btnDisable || (!formik?.values?.mobileNoVerified)}
                          >
                            Continue
                          </button>
                        </div>
                      </div>}
                    {subStageValue === 'product_selection' &&
                      <div className="col-sm-12">
                        <div className="d-flex">
                          <button
                            className="btn btn-primary w-100 small continue-btn"
                            type="button"
                            onClick={() => { createUserApplication() }}
                            disabled={(!formik?.values?.product)}
                          >
                            Proceed
                          </button>
                        </div>
                      </div>}
                  </div>
                </div>
              </footer>
            </div>

          </div>

        </>}

      {showSuspectConfirmModal &&
        <>
          <div className="modal fade show d-block" tabIndex="-1" aria-modal="true">
            <div className="modal-dialog bottom-modal">
              <div className="modal-content custom-padding pt-0">
                <div className="modal-header">
                  <div className="top-draw"></div>
                </div>
                <div className="modal-body text-center p-0">
                  <ImageComponent fileName='2fverify.svg' alt="2fverify" />
                  <p className='fw-600 mt-4'>Are you sure you want to mark this login as Suspected Activity ?</p>

                  <div className="modal-footer border-0 p-0">
                    <div className="row w-100">
                      <div className="col-6 ps-0">
                        <button
                          className="btn btn-outline-primary w-100"
                          type="button"
                          onClick={() => {
                            formik.setFieldValue('suspected_activity', false);
                            setShowSuspectConfirmModal(false);
                          }}
                        >
                          No
                        </button>
                      </div>
                      <div className="col-6 pe-0">
                        <button
                          className="btn btn-primary w-100"
                          type="button"
                          onClick={() => setShowSuspectConfirmModal(false)}
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }

      {showModal &&
        <>
          <div className="modal fade show" id="SelectRole" aria-labelledby="SelectRole" tabIndex="-1" style={{ display: "block" }} aria-modal="true"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setShowModal(false)
              }
            }}
            onClick={() => setShowModal(false)}>
            <div
              className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg bottom-modal"
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.stopPropagation()
                }
              }}
              onClick={(e) => e.stopPropagation()}
            >

              <div className="modal-content">
                <div className="modal-body otp-modal mt-3 mb-3">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-3 d-flex justify-content-between align-items-start">
                      <ImageComponent fileName="eligibleotp.svg" alt="eligimob" />
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                      <p className="form-label fw-semibold fs-6">Please Enter OTP Sent to:</p>
                      <p className="form-label d-none fs-7">
                        A 6 digit code has been sent to :
                      </p>

                      <div className="mt-2">
                        <p className="fw-semibold form-label fs-7">
                          {formatMobileNumber(formik?.values?.mobileNo)}
                        </p>
                      </div>

                      <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                        <div>
                          <div className="d-flex mb-4 eligibility-otp-tab">
                            {otpValues.map((value, index) => (
                              <input
                                key={otpIds[index]}
                                type="tel"
                                maxLength="1"
                                value={value}
                                onChange={(e) => handleOtpChange(index, e.target.value)}
                                onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                onPaste={handleOtpPaste}
                                data-index={index}
                                className="otp-in input-underline otp-input"
                                inputMode="numeric"
                                autoComplete="one-time-code"
                              />
                            ))}
                          </div>
                        </div>
                      </div>
                      <div className='head-title mt-3'>
                        {timer !== "00:00" ? (
                          `Resend OTP in ${timer} seconds`
                        ) : (
                          <a
                            href={href}
                            tabIndex={0}
                            className="anchor-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              resendOtp();
                            }}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                resendOtp();
                              }
                            }}
                          >
                            Resend
                          </a>
                        )}
                        <br></br>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                      <button
                        className="btn btn-primary btn-lg w-100 signin"
                        type="button"
                        disabled={otpValues.join('')?.length !== 6}
                        onClick={() => { verifyOtp() }}
                      >
                        Verify
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }

      {showconfirmModal &&
        <>
          <div className="modal fade show" id="success-dealer" aria-labelledby="SelectRole" tabIndex="-1" style={{ display: "block" }} aria-modal="true">
            <div
              className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg bottom-modal"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <div className="top-draw"></div>
                </div>
                <div className="modal-body text-center">
                  <p className="dark-blue">Please confirm to proceed with
                  </p>
                  <p className="text-center mb-0 fs-6">
                    <span className="fw-semibold">{showconfirmModal} - {selectedDealer?.dealername}</span>
                  </p>
                  <p className="location-address">
                    <i className="icon-location me-1"></i>
                    <span>{selectedDealer?.dealeraddress}</span>
                  </p>
                  <button className="btn btn-primary btn-lg w-50 signin" type="button" onClick={() => { checkStatus() }} >Next</button>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <div className="icon-arrowleftl1" role="button"
                      tabIndex={0}
                      onClick={(e) => {
                        e.preventDefault();
                        setShowconfirmModal(false)
                        setDelearListModal(true)
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          setShowconfirmModal(false)
                          setDelearListModal(true)
                        }
                      }}></div>
                    <div>
                      <a
                        href="/dashboard"
                        onClick={(e) => {
                          e.preventDefault();
                          setShowconfirmModal(false)
                          setDelearListModal(true)
                        }}
                      >
                        Back
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }


      {delearListModal &&
        <>
          <div
            className="modal fade show"
            tabIndex="-1"
            style={{ display: "block" }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setDelearListModal(false)
              }
            }}
            onClick={() => setDelearListModal(false)}
          >
            <div className="modal-dialog bottom-modal">
              <div className="modal-content blue"
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.stopPropagation()
                  }
                }}
                onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <div className="top-draw"></div>
                </div>
                <div className="d-flex align-items-center justify-content-between px-4">
                  <h6 className="mb-1">Stores</h6>
                </div>
                <div className="modal-body">
                  {/* Search Bar */}
                  <form className="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3 position-relative" role="search" onSubmit={(e) => e.preventDefault()}>
                    <input
                      type="search"
                      className="form-control input-underline"
                      placeholder="Search store"
                      aria-label="Search"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <div className="has-i-search hidden-search-box eligibility-search">
                      <span className="icon-searchnormal fs-4 inside-search"></span>
                    </div>
                  </form>

                  {/* Dealer List */}
                  <ul className="list-group list-group-flush lh-lg ul-height">
                    {filteredDealers.length > 0 ? (
                      filteredDealers.map((data) => (
                        <li key={data.dealercode} className="list-group-item border-0">
                          <button
                            type="button"
                            className="list-group-item border-0 text-secondary fw-normal p-0 bg-transparent w-100 text-start"
                            onClick={() => {
                              showModalPopup(data.dealercode)
                              setDelearListModal(false)
                              setSearchTerm('');
                            }}
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          >
                            {data.dealercode} – {data.dealername}
                          </button>
                        </li>
                      ))
                    ) : (
                      <li className="list-group-item border-0 text-muted">No dealers found.</li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }

      {successModal &&
        <>
          <div className="modal fade show" id="SelectRole" aria-labelledby="SelectRole" tabIndex="-1" style={{ display: "block" }} aria-modal="true">
            <div
              className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg bottom-modal"
            >
              <div className="modal-content">
                <div className="modal-body text-center mt-3 mb-3">
                  <div className="row gy-3">
                    <div className="col-lg-12 col-md-12 col-sm-12 ">
                      <ImageComponent fileName="congrats.gif" className="img-fluid gif-tick" alt="ico-success" />
                      <p className="fw-semibold fs-4 mt-3 text-uppercase">{formik?.values?.name?.toUpperCase()}
                      </p>
                      <p className="small fs-6">{successModal}</p>
                      <p className="small fs-6">Application ID: <b>{referenceId}</b></p>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 ">
                      <button className="btn btn-primary w-50" type="button" onClick={() => { handleKycLink() }}>Proceed</button>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <a
                        href={href}
                        tabIndex={0}
                        className="anchor-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('/dashboard');
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            navigate('/dashboard');
                          }
                        }}
                      >
                        Home
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }
      {existingCase &&
        <>
          <div className="modal fade show" id="existingcred" tabIndex="-1" aria-labelledby="existingcred" style={{ display: "block" }} aria-hidden="true">
            <div className="modal-dialog bottom-modal">
              <div className="modal-content">

                <div className="addon_popup-div text-center">
                  <ImageComponent fileName="exist.svg" />

                  <p className="fw-semibold m-0 mt-3 mb-1">Another Application with Same Credentials is Identified</p>
                  <div className="exist-pop mb-4">
                    <div className="row mt-3 p-3 gy-2">
                      <div className="col-6 col-lg-6 col-md-6 text-start">
                        Application Number
                      </div>
                      <div class="col-6 col-lg-6 col-md-6 text-end dark-blue">
                        {existingCase?.reference_id}
                      </div>

                      <div className="col-6 col-lg-6 col-md-6 text-start">
                        Customer Name
                      </div>
                      <div class="col-6 col-lg-6 col-md-6 text-end dark-blue">
                        {existingCase?.first_name + " " + existingCase?.last_name}
                      </div>

                      <div className="col-6 col-lg-6 col-md-6 text-start">
                        Dealer Name
                      </div>
                      <div class="col-6 col-lg-6 col-md-6 text-end dark-blue">
                        {existingCase?.dealer_name}
                      </div>

                      <div className="col-6 col-lg-6 col-md-6 text-start">
                        Stage </div>
                      <div class="col-6 col-lg-6 col-md-6 text-end dark-blue">{existingCase?.stage?.split('_')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ')}
                      </div>

                      {existingCase?.category &&
                        <>
                          <div className="col-6 col-lg-6 col-md-6 text-start">
                            Asset
                          </div>
                          <div className="col-6 col-lg-6 col-md-6 text-end dark-blue">{existingCase?.category}
                          </div>
                        </>}

                      {existingCase?.kyc_reuse &&
                        <div className="col-12">
                          <div className="form-group mt-2">
                            <div className="form-check d-flex">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="flexCheckDefault"
                                onChange={(e) => setKycReUse(e.target.checked)}
                              />
                              <label className="form-check-label small" htmlFor="flexCheckDefault">
                                Agree to use the same KYC?
                              </label>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>

                  <div className="d-flex w-100">
                    {!kycReuse && <button className="btn btn-outline-primary si" type="button"
                      onClick={() => saveApplicationId(existingCase?.reference_id, referenceId, "cancel")}>OK, got it!</button>}

                    {errCode !== 'E194' && <button className="btn btn-primary ms-auto" type="button" disabled={!kycReuse && existingCase?.kyc_reuse === true}
                      onClick={() => saveApplicationId(referenceId, existingCase?.reference_id, "confirm")}>Confirm</button>}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }
      {
        anmolModal &&
        <>
          <div className="modal show fade" id="verifyModal" tabIndex="-1" aria-labelledby="verifyModalLabel" style={{ display: "block" }} aria-hidden="true">
            {showAnmolErrorGif && (
              <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 3 }}>
                <ImageComponent fileName="conf.gif" className="img-fluid" alt="Error" />
              </div>
            )}
            <div className="modal-dialog bottom-modal">
              <div className="modal-content top-anmol" style={{ position: 'relative', overflow: 'hidden' }}>
                {/* Background image using ImageComponent, only top 50% */}
                <ImageComponent
                  fileName="anmollll.png"
                  className="position-absolute w-100"
                  alt="anmollll-bg"
                  style={{ top: 0, left: 0, zIndex: 0, objectFit: 'cover', height: '51%', width: '100%' }}
                />
                <div className="modal-header anmol-top-draw">
                  <div className="top-draw head-line"></div>
                </div>
                <div className="modal-body anmol-body position-relative pb-0">
                  <p className='text-center fs-6 text-white d-none'><span className='anmol-light'>Verify you are an</span> <span className='anmol-bold'>ANMOL</span> <span className='anmol-light'>customer</span></p>

                  {/* Content above background image */}
                  <div className="row" style={{ position: 'relative', zIndex: 2 }}>
                    <p className="fw-semibold d-none fs-6"> Enter Anmol Number</p>
                    <div className="col-12">
                      <div className="col-12 position-relative">
                        <div>
                          <ImageComponent fileName="anmol2.svg" className="img-fluid anmol-width w-100" />
                        </div>

                        <div className="position-absolute anmol-c col-10">
                          <label htmlFor='anmol' className="form-label text-white">Enter Anmol Number</label>
                          <input className="form-control input-underline-anmol bg-transparent" type="tel" maxLength={16} onChange={(e) => { setAnmolNumber(e.target.value) }} placeholder="XXXX XXXX XXXX XXXX" autoFocus />
                        </div>
                      </div>
                    </div>

                    <div className="col-12 mt-4 mb-4">
                      <div className="d-flex justify-content-between gap-3">
                        <button className="btn btn-outline-primary px-5" type="button"
                          disabled={showAnmolErrorGif}
                          onClick={() => {
                            setShowAnmolErrorGif(false);
                            setAnmolModal(false)
                          }}>Skip</button>

                        <button className="btn btn-primary px-5 w-100" type="button"
                          disabled={anmolNumber?.length !== 16 || showAnmolErrorGif}
                          onClick={() => { checkAnmolData() }}>Proceed</button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }
      {
        pan &&
        <>
          <div className="modal show fade" id="panpop" tabIndex="-1" aria-labelledby="existingcred" style={{ display: "block" }} >

            <div className="modal-dialog bottom-modal">
              <div className="modal-content">

                <div className="px-3 py-3 text-center">
                  <ImageComponent fileName="exist.svg" />

                  <p className="fw-semibold m-0 mt-3">Please Confirm the PAN Number</p>
                  <div className="row mt-3 gy-2">
                    <div className="col-12">
                      <p className="current-primary fw-semibold">{pan}</p>
                    </div>

                    <div className="col-12">
                      <div className="d-flex justify-content-between mt-4">
                        <button className="btn btn-outline-primary px-5" type="button"
                          onClick={() => { setPan() }}>No</button>

                        <button className="btn btn-primary px-5" type="button"
                          onClick={() => { setPanNumber() }}>Yes</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }
      {
        rejectPopup &&
        <>
          <div className="modal show fade" id="rejectpopup" tabIndex="-1" aria-labelledby="rejectpopup" aria-hidden="true" style={{ display: "block" }}>
            <div className="modal-dialog bottom-modal">
              <div className="modal-content">
                <div className="px-3 py-3 text-center">
                  <ImageComponent fileName="rejected.gif" className="gif-cross" />
                  <p className="fw-semibold m-0 mt-3">{formik?.values?.name?.toUpperCase()}</p>
                  <p className="mt-3">{rejectPopup}</p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <div>
                      <a href={href}
                        onClick={(e) => {
                          e.preventDefault();
                          navigate('/dashboard');
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            navigate('/dashboard');
                          }
                        }}>Home</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }
      {
        geoErrorPopup &&
        <>
          <div className="modal show fade d-block" id="geoerrorpopup" tabIndex="-1" aria-labelledby="geoerrorpopup" aria-hidden="true">
            <div className="modal-dialog bottom-modal">
              <div className="modal-content">
                <div className="px-3 py-3 text-center">
                  <ImageComponent fileName="geo-error.svg" />
                  <p className="text-danger fw-600 fs-32 mt-4">ERROR !</p>
                  <p className="fw-semibold m-0 mt-3">{formik?.values?.name?.toUpperCase()}</p>
                  <p className="mt-3">{geoErrorPopup}</p>
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <div className='w-75'>
                      <button type="button" className="btn btn-primary w-100" onClick={() => setGeoErrorPopup(false)}>Proceed</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }
      {
        cKycPopup &&
        <>
          <div className="modal show fade" id="verifyModal" tabIndex="-1" aria-labelledby="verifyModalLabel" style={{ display: "block" }} aria-hidden="true">
            <div className="modal-dialog bottom-modal">
              <div className="modal-content">
                <div class="ckyc-card">
                  <div class="ckyc-header">
                    <div class="ckyc-avatar">
                      {!!cKycPopup?.image && (
                        <>
                          <img src={'data:image/png;base64,' + cKycPopup?.image} alt='selfie' />
                        </>
                      )}
                    </div>

                    {!ckycSummary &&
                      <div class="ckyc-name">
                        <span class="label">Name</span>
                        <span class="value">{cKycPopup?.name}</span>
                      </div>
                    }
                  </div>

                  {!ckycSummary &&
                    <>
                      <div class="ckyc-details-grid">
                        <div class="detail">
                          <span class="label">C-KYC Number</span>
                          <span class="value">{cKycPopup?.ckycNo}</span>
                        </div>

                        <div class="detail text-end">
                          <span class="label">Father Name</span>
                          <span class="value">{cKycPopup?.fatherName}</span>
                        </div>

                        <div class="detail">
                          <span class="label">Verification Date</span>
                          <span class="value">{convertDateFormat(cKycPopup?.kycDate)}</span>
                        </div>

                        <div class="detail text-end">
                          <span class="label">Last Updated On</span>
                          <span class="value">{convertDateFormat(cKycPopup?.updatedOn)}</span>
                        </div>
                      </div>


                      {!otpId &&
                        <div class="ckyc-action-section mt-2">
                          <p class="ckyc-question">
                            Do you want to continue with C-KYC verification ?
                          </p>

                          <div className="ckyc-actions d-flex justify-content-center align-items-center">
                            <button
                              className="btn ckyc-btn-skip d-none"
                              type="button"
                              onClick={() => { createUserApplication(values); setCkycPopup(null) }}
                            >
                              <span className="ckyc-icon me-2">✖</span>
                              Skip for now
                            </button>

                            <button
                              className="btn ckyc-btn-continue d-flex align-items-center justify-content-center btn-lg w-100"
                              type="button"
                              onClick={() => { generateCkycotp() }}
                            >
                              <span className="d-none ckyc-icon me-2">✔</span>
                              Continue
                            </button>
                          </div>
                        </div>}
                      {otpId &&
                        <>
                          <div className="col-lg-12 col-md-12 col-sm-12 mb-3 mt-2">
                            <p className="form-label fw-semibold fs-6">Please Enter OTP Sent to:</p>
                            <p className="form-label d-none fs-7">
                              A 6 digit code has been sent to :
                            </p>

                            <div className="mt-2">
                              <p className="fw-semibold form-label fs-7">
                                {formatMobileNumber(cKycPopup?.mobileNumber)}
                              </p>
                            </div>

                            <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                              <div>
                                <div className="d-flex mb-4 eligibility-otp-tab">
                                  {otpValues.map((value, index) => (
                                    <input
                                      key={otpIds[index]}
                                      type="tel"
                                      maxLength="1"
                                      value={value}
                                      onChange={(e) => handleOtpChange(index, e.target.value)}
                                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                      onPaste={handleOtpPaste}
                                      data-index={index}
                                      className="otp-in input-underline otp-input"
                                      inputMode="numeric"
                                      autoComplete="one-time-code"
                                    />
                                  ))}
                                </div>
                              </div>
                            </div>
                            <div className='head-title mt-3'>
                              {timer !== "00:00" ? (
                                `Resend OTP in ${timer} seconds`
                              ) : (
                                <a
                                  href={href}
                                  tabIndex={0}
                                  className="anchor-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    generateCkycotp();
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      e.preventDefault();
                                      generateCkycotp();
                                    }
                                  }}
                                >
                                  Resend
                                </a>
                              )}
                              <br></br>
                            </div>
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                            <button
                              className="btn btn-primary btn-lg w-100 signin"
                              type="button"
                              disabled={otpValues.join('')?.length !== 6}
                              onClick={() => { verifyCkycOtp() }}
                            >
                              Verify
                            </button>
                          </div>
                        </>
                      }
                    </>
                  }
                  {ckycSummary &&
                    <><div className="d-flex justify-content-between">
                      <p className="fs-6 fw-semibold text-uppercase">Personal Information</p>
                      {/* <LinkAction title="Modify" onClick={handleModify} /> */}
                    </div>
                      <div class="ckyc-details-grid mb-2">

                        <div class="detail">
                          <span class="label">Name</span>
                          <span class="value">{ckycSummary?.result?.personalDetails?.personalInfo?.fullName}</span>
                        </div>
                        <div class="detail text-end">
                          <span class="label">C-KYC Number</span>
                          <span class="value">{isValueCkycMasked ? maskValue(ckycSummary?.result?.personalDetails?.ckycId, 'ckyc') : ckycSummary?.result?.personalDetails?.ckycId}
                            <i
                              className={isValueCkycMasked ? 'icon-securityeye-slash' : 'icon-securityeye'}
                              onClick={() => setIsValueCkycMasked(!isValueCkycMasked)}
                              onKeyDown={() => setIsValueCkycMasked(!isValueCkycMasked)}
                              role="button"
                            ></i>
                          </span>
                        </div>

                        <div class="detail ">
                          <span class="label">Mobile Number</span>
                          <span class="value">{isValueMobileMasked ? maskValue(ckycSummary?.result?.personalDetails?.mobileNumber, 'mobilenumber') : ckycSummary?.result?.personalDetails?.mobileNumber}
                            <i
                              className={isValueMobileMasked ? 'icon-securityeye-slash' : 'icon-securityeye'}
                              onClick={() => setIsValueMobileMasked(!isValueMobileMasked)}
                              onKeyDown={() => setIsValueMobileMasked(!isValueMobileMasked)}
                              role="button"
                            ></i>
                          </span>
                        </div>
                        {console.log(isValueDobMasked, ckycSummary?.result?.personalDetails?.personalInfo?.dob, isValueMobileMasked, ckycSummary?.result?.personalDetails?.personalInfo?.mobileNumber)}

                        <div class="detail text-end">
                          <span class="label">DOB</span>
                          <span class="value">{isValueDobMasked ? maskValue(ckycSummary?.result?.personalDetails?.dob, 'dob') : convertDateFormat(ckycSummary?.result?.personalDetails?.dob)}
                            <i
                              className={isValueDobMasked ? 'icon-securityeye-slash' : 'icon-securityeye'}
                              onClick={() => setIsValueDobMasked(!isValueDobMasked)}
                              onKeyDown={() => setIsValueDobMasked(!isValueDobMasked)}
                              role="button"
                            ></i>
                          </span>
                        </div>
                      </div>

                      <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                        <button
                          className="btn btn-primary btn-lg w-100 signin"
                          type="button"
                          onClick={() => { setSubStageValue('product_selection'); setCkycPopup(null) }}
                        >
                          Proceed
                        </button>
                      </div>
                    </>
                  }
                </div>

                {/* <div className="col-12 col-md-12">
                  <div className="dataView c-kyc-profile">
                    <div className="row gy-3">
                      <div className="col-12 col-md-12">
                        <div className="d-flex align-items-center gap-3">
                          {!!cKycPopup?.image && (
                            <>
                              <img className="selfie-icon" src={'data:image/png;base64,' + cKycPopup?.image} selfieClass="" />
                            </>
                          )}
                          <p>
                            <label>Name</label>
                            <span>{cKycPopup?.name}</span>
                          </p>
                        </div>
                      </div>
                      <div className="col-6 col-md-6">
                        <p>
                          <label>C-KYC Number</label>
                          <span>{cKycPopup?.ckycNo}</span>
                        </p>
                      </div>
                      <div className="col-6 col-md-6">
                        <p>
                          <label>Father Name</label>
                          <span>{cKycPopup?.fatherName}</span>
                        </p>
                      </div>
                      <div className="col-6 col-md-6">
                        <p>
                          <label>Verification Date</label>
                          <span>{convertDateFormat(cKycPopup?.kycDate)}</span>
                        </p>
                      </div>
                      <div className="col-6 col-md-6">
                        <p>
                          <label>Last Updated On</label>
                          <span>{convertDateFormat(cKycPopup?.updatedOn)}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="kyc-verify-btn mt-3">
                    <p className="form-label">Do you want to continue with C-KYC verification ?</p>
                    <div className="d-flex align-content-center gap-2">
                      <button
                    type="button"
                    className={`btn ${values.ckycVerificationConsent === false ? 'skip-select' : ''}`}
                    onClick={() => setFieldValue('ckycVerificationConsent', false)}
                  >
                    {' '}
                    <i className="icon-arrowClose text-danger"> </i>Skip for now
                  </button>
                  <button
                    type="button"
                    className={`btn ${values.ckycVerificationConsent === true ? 'yes-select' : ''}`}
                    onClick={() => setFieldValue('ckycVerificationConsent', true)}
                  >
                    {' '}
                    <i className="icon-Essetional-Tick-1 text-success"> </i> Yes, Continue
                  </button>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      }
      {loader === true && <Loader />}
    </form >

  )
}

export default EligiblityCheck